import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Device} from "../../../shared/interface/device";
import {License} from "../../../shared/interface/license";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {Profile} from "../../../shared/interface/profile";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {LicenseService} from "../../../shared/services/license.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {takeUntil} from "rxjs/operators";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {ListResponse} from "../../../shared/interface/response/list-response";

@Component({
  selector: 'app-device-details-view',
  templateUrl: './device-details-view.component.html',
  styleUrls: ['./device-details-view.component.scss']
})
export class DeviceDetailsViewComponent implements OnInit, OnDestroy {

  @Input() device: Observable<Device>;
  @Output() modifyClicked = new EventEmitter<void>();

  deviceObject: Device;
  userPermissions: ReplaySubject<UserPermissions>;
  licenses: ReplaySubject<License[]> = new ReplaySubject<License[]>(1);
  deviceId?: string = null;
  profile: Profile;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private licenseService: LicenseService,
    private snack: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
    this.device
      .pipe(takeUntil(this.destroyed$))
      .subscribe((device: Device) => {
        this.deviceObject = device;
      });
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.deviceId = params.id;
        this.loadLicenses();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć urządzenie?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.licenseService.deleteDevice(this.deviceObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto urządzenie', '', {duration: 2000});
            this.router.navigate(['/licencje/urzadzenia']);
          });
      }
    });
  }

  loadLicenses(): void {
    this.licenseService.getDeviceLicenses(this.deviceId)
      .subscribe((licenses: ListResponse<License>) => {
        this.licenses.next(licenses.items);
      });
  }

}
